import { render, staticRenderFns } from "./SettingsHome.vue?vue&type=template&id=7d0ddc45&scoped=true"
import script from "./SettingsHome.vue?vue&type=script&lang=js"
export * from "./SettingsHome.vue?vue&type=script&lang=js"
import style0 from "./SettingsHome.vue?vue&type=style&index=0&id=7d0ddc45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ddc45",
  null
  
)

export default component.exports